import * as Yup from 'yup';

const SigninSchema = Yup.object().shape({
  email: Yup.string().email('invalidEmail').required('required.email'),
  password: Yup.string().required('required.password'),
});

export default SigninSchema;
